import { render, staticRenderFns } from "./child-account-login.vue?vue&type=template&id=394607a2&scoped=true&"
import script from "./child-account-login.vue?vue&type=script&lang=js&"
export * from "./child-account-login.vue?vue&type=script&lang=js&"
import style0 from "./child-account-login.vue?vue&type=style&index=0&id=394607a2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394607a2",
  null
  
)

export default component.exports